import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import ProjectModal from './ProjectModal';

const ProjectCard = ({ title, description, image, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);

  

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const projectDetails = { title, description, image };

  return (
    <>
      <div
        ref={ref}
        className={`bg-gray-700 p-4 md:p-6 rounded-lg shadow-lg transform transition duration-500 delay-${delay} hover:scale-105 hover:shadow-lg  ${inView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
       // onClick={openModal}
      >
        <img src={image} alt={title} className="w-full h-32 md:h-48 object-cover mb-4 rounded-md shadow-md" />
        <h3 className="text-xl md:text-2xl font-bold mb-4">{title}</h3>
        <p className="text-gray-400 text-sm md:text-base">{description}</p>
      </div>
      <ProjectModal isOpen={modalIsOpen} onRequestClose={closeModal} project={projectDetails} />
    </>
  );
};

export default ProjectCard;
